import React from "react";
import SetupCard from "src/pages/GetStarted/Onboarding/SetupCard";
import connectPlatformsIcon from "src/assets/onboarding/connectPlatforms.svg";
import { completeUserSetupQuestionCardConnectPlatforms } from "src/apiService/modules/users";

const ConnectPlatformsCard = ({
  onClick,
  completed = false,
}: {
  onClick: () => void;
  completed?: boolean;
}) => {
  return (
    <SetupCard
      title="Connect Platforms"
      imageSrc={connectPlatformsIcon}
      description="Go to Integrations to connect your selling platforms. You can choose whether to import past data."
      buttonText="Connect Platforms"
      onButtonClick={onClick}
      points={30}
      completed={completed}
      onManualComplete={() =>
        completeUserSetupQuestionCardConnectPlatforms({
          source: "user-dismissed",
        })
      }
    />
  );
};

export default ConnectPlatformsCard;
